// 动态按需加载多语言文案，仅加载当前 locale 与 en 兜底

export type LangMessages = Record<string, any>;

function normalizeLocale(locale?: string): string {
  if (!locale) return "en";
  return locale;
}

async function importLocaleFile(locale: string): Promise<any | undefined> {
  switch (locale) {
    case "zh-CN":
      return (await import("./lang/cn.json")).default;
    case "zh-HK":
      return (await import("./lang/hk.json")).default;
    case "id":
      return (await import("./lang/in.json")).default;
    case "en":
      return (await import("./lang/en.json")).default;
    case "es":
      return (await import("./lang/es.json")).default;
    case "hi":
      return (await import("./lang/hi.json")).default;
    case "ja":
      return (await import("./lang/ja.json")).default;
    case "ko":
      return (await import("./lang/ko.json")).default;
    case "th":
      return (await import("./lang/th.json")).default;
    case "tr":
      return (await import("./lang/tr.json")).default;
    case "vi":
      return (await import("./lang/vi.json")).default;
    case "fil":
      return (await import("./lang/fil.json")).default;
    case "km":
      return (await import("./lang/km.json")).default;
    case "ms":
      return (await import("./lang/ms.json")).default;
    case "it":
      return (await import("./lang/it.json")).default;
    case "fr":
      return (await import("./lang/fr.json")).default;
    case "de":
      return (await import("./lang/de.json")).default;
    case "ru":
      return (await import("./lang/ru.json")).default;
    default:
      return undefined;
  }
}

export async function loadLocaleMessages(localeInput?: string): Promise<LangMessages> {
  const locale = normalizeLocale(localeInput);
  const [current, en] = await Promise.all([
    importLocaleFile(locale),
    importLocaleFile("en"),
  ]);
  const result: LangMessages = {};
  if (en) result["en"] = en;
  if (current && locale !== "en") result[locale] = current;
  return result;
}
